export default "__VITE_ASSET__C$ZIKsDq__"